// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { API_BASE_URL } from "../../../Config/Config";

// export const fetchRoleData = createAsyncThunk(
//   "api/fetchCreateRole",
//   async () => {
//     const response = await fetch(
//       `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-role-screen-access_all/`
//     );
//     const data = await response.json();
//     return data;
//   }
// );

// const createRoleSlice = createSlice({
//   name: "createRole",
//   initialState: {
//     data: null,
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchRoleData.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchRoleData.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//       })
//       .addCase(fetchRoleData.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message;
//       });
//   },
// });

// export default createRoleSlice.reducer;













import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../../Api/Endpoints";

export const fetchRoleData = createAsyncThunk(
  "createRole/fetchRoleData",
  async (_, { rejectWithValue }) => {
    try {
      const accessToken = localStorage.getItem("other");

      const response = await fetch(
        `${EndPoints.PRISM_GET_ROLE_SCREEN_ACCESS_ALL}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const createRoleSlice = createSlice({
  name: "createRole",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

      // Pending
      .addCase(fetchRoleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      // Fulfilled
      .addCase(fetchRoleData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })

      // Rejected
      .addCase(fetchRoleData.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || action.payload || "Something went wrong";
      });
  },
});

export default createRoleSlice.reducer;